import { render, staticRenderFns } from "./ContactInformationOnk.vue?vue&type=template&id=6b90a5ad&scoped=true&ref=adminUser&"
import script from "./ContactInformationOnk.vue?vue&type=script&lang=js&"
export * from "./ContactInformationOnk.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformationOnk.vue?vue&type=style&index=0&id=6b90a5ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90a5ad",
  null
  
)

export default component.exports